import script from "./RightToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightToolbar.vue?vue&type=script&setup=true&lang=js"

import "./RightToolbar.vue?vue&type=style&index=0&id=4680bbec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4680bbec"]])

export default __exports__